module.exports = __webpack_public_path__ + "img/focus_1.755b9c67.png";